export function errorMessage(op: string, resource: string, status: number) {
  let message = `Failed to ${op} ${resource}`
  if(status === 400) {
    message += ". Please check your input."
  }
  if(status === 500) {
    message += " due to server error. Please try again."
  }
  return message.endsWith(".") ? message : message + "."
}
